/**
 * @module "behavior/bind.registered.view.events.behavior"
 * @property {Object} defaults - name, viewBindings
 * @description This needs a description
 */

define('formkit/behavior/bind.registered.view.events.behavior',['require','exports','module','underscore','backbone','marionette','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      Backbone = require('backbone'),
      Mn = require('marionette'),
      Radio = require('backbone.radio');

  /**
   * @class  BindRegisteredViewEventsBehavior
   * @augments external:Mn.Behavior
   */
  var BindRegisteredViewEventsBehavior = Mn.Behavior.extend({
    defaults: {
      name: null,
      viewBindings: {},
    },

    /**
     * @method initialize
     * @constructs
     * @augments external:Mn.Behavior
     */
    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);
      this.checkViewExists();
    },

    /**
     * @method bindEvents
     */
    bindEvents: function() {
      var targetView = this.getView();
      var viewEvents = _.extend({}, this.getOption('viewEvents'));
      _.each(
        viewEvents,
        function(methodName, eventName) {
          if (!_.isFunction(this.view[methodName])) {
            return;
          }
          this.listenTo(targetView, eventName, function() {
            this.view[methodName].apply(this.view, arguments);
          });
        },
        this
      );
    },

    /**
     * @method checkViewExists
     */
    checkViewExists: function() {
      var view = this.getView();
      if (view instanceof Backbone.View) {
        this.bindEvents();
      } else {
        Radio.once('viewInstances', 'reply:' + this.getOption('name'), this.checkViewExists, this);
      }
    },

    /**
     * @method getView
     *
     * @returns {Object}  name view
     */
    getView: function() {
      return Radio.request('viewInstances', this.getOption('name'));
    },

    /**
     * @method onDestroy
     */
    onDestroy: function() {
      Radio.off('viewInstances', 'reply:' + this.getOption('name'), this.checkViewExists, this);
    },
  });

  module.exports = BindRegisteredViewEventsBehavior;
});

